import { LinkButton } from 'elements/LinkButton'
import React, { useState } from 'react'
import { Dropdown, Input } from 'semantic-ui-react'

export default function MultiSurveyLanguageDropdown({
  filteredLanguages,
  handleAddLanguage,
  search,
  setSearch,
}) {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false)

  return (
    <Dropdown
      open={isOpenDropdown}
      onOpen={() => setIsOpenDropdown(true)}
      onClose={() => setIsOpenDropdown(false)}
      closeOnChange={false}
      trigger={
        <LinkButton
          className="font-normal text-[14px]"
          onClick={(e) => {
            e.preventDefault()
            setIsOpenDropdown((prev) => !prev)
          }}
        >
          <i className="icon far fa-plus" />
          Add language
        </LinkButton>
      }
      icon={null}
      floating
      className="icon"
    >
      <Dropdown.Menu>
        <Input
          icon="far fa-magnifying-glass"
          iconPosition="right"
          placeholder="Search languages..."
          value={search}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => setSearch(e.target.value)}
        />
        <Dropdown.Divider className="!mb-0" />
        <Dropdown.Menu scrolling className="!border-none">
          {filteredLanguages.length === 0 ? (
            <Dropdown.Item disabled text="No languages available" />
          ) : (
            filteredLanguages.map(([name, code]) => (
              <Dropdown.Item
                key={code}
                text={name}
                onClick={(e) => {
                  {
                    e.stopPropagation()
                    handleAddLanguage(code)
                  }
                }}
              />
            ))
          )}
        </Dropdown.Menu>
      </Dropdown.Menu>
    </Dropdown>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/MultiSurveyLanguageDropdown/index.js